// Partially following https://ui.dev/react-router-protected-routes-authentication/
import { useGetCurrentPlayerQuery, useLoginMutation, useLogoutMutation } from "../../services/moderatorApi";

function useUser() {
  const { data, error, isLoading } = useGetCurrentPlayerQuery();
  const [updateLogin, { isLoading: loginUpdating, error: loginError }] = useLoginMutation();
  const [updateLogout, { isLoading: logoutUpdating, error: logoutError }] = useLogoutMutation();

  const isUpdating = loginUpdating || logoutUpdating;

  return {
    user: data,
    userError: error,
    userLoading: isLoading,
    userUpdating: isUpdating,
    userLoginError: loginError,
    userLogoutError: logoutError,
    isModerator: data && data.moderator,
    login: updateLogin,
    logout: updateLogout,
  };
}

export default useUser;
